<template>
  <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2">
    <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Display</span>
    <div class="wf-w-1/2 wf-flex wf-justify-end">
      <button
        @click.prevent="toggleDisplayInDevice('phone')"
        class="focus:wf-outline-none wf-h-6 wf-w-6 wf-text-xs wf-flex wf-rounded wf-items-center wf-justify-center"
        :class="displayIn('phone') ? ['wf-bg-blue-500', 'wf-text-white'] : ['wf-text-gray-500']"
      >
        <i class="fas fa-mobile-alt"></i>
      </button>
      <button
        @click.prevent="toggleDisplayInDevice('tablet')"
        class="focus:wf-outline-none wf-ml-2 wf-h-6 wf-w-6 wf-text-xs wf-flex wf-rounded wf-items-center wf-justify-center"
        :class="displayIn('tablet') ? ['wf-bg-blue-500', 'wf-text-white'] : ['wf-text-gray-500']"
      >
        <i class="fas fa-tablet-alt"></i>
      </button>
      <button
        @click.prevent="toggleDisplayInDevice('desktop')"
        class="focus:wf-outline-none wf-ml-2 wf-h-6 wf-w-6 wf-text-xs wf-flex wf-rounded wf-items-center wf-justify-center"
        :class="displayIn('desktop') ? ['wf-bg-blue-500', 'wf-text-white'] : ['wf-text-gray-500']"
      >
        <i class="fas fa-desktop"></i>
      </button>
    </div>
  </li>
</template>

<script>
  import { DisplayClasses } from '../classes/DisplayClasses'
  import MenuStyleProperty from '../contracts/MenuStyleProperty'
  export default MenuStyleProperty.extend({
    created() {
      this.initDisplayClasses()
    },
    computed: {
      displayClasses() {
        return Object.keys(DisplayClasses)
      }
    },
    methods: {
      initDisplayClasses() {
        Object.keys(this.elementClasses(this.classes)).forEach(device => {
          let displayClass = this.elementClasses(this.classes)[device].find(property => this.displayClasses.includes(property.value))
          if(! displayClass) {
            this.addToArray(this.module, [{property: 'Display', value: 'BLOCK', touched : true}], this.classes, this.device, {}, true, this.parentModule)
          }
        })
      },
      displayIn(device) {
        return this.elementClasses(this.classes)[device].find(property => property.property === 'Display' && property.value === 'BLOCK')
      },
      toggleDisplayInDevice(device) {
        let value = 'BLOCK'
        let currentDisplay = this.elementClasses(this.classes)[device].find(elementClass => this.displayClasses.includes(elementClass.value))
        if (currentDisplay.value == value) {
          let inDevices = Object.keys(this.elementClasses(this.classes)).filter(device => !! this.elementClasses(this.classes)[device].find(property => property.property == 'Display' && property.value == 'NONE'))
          if (inDevices.length == 2) {
            alert('The element has to be visible in at least one device')
            return
          }
          value = 'NONE'
        }
        value = {property: 'Display', value: value, touched: currentDisplay.touched}
        this.addToArray(this.module, [value], this.classes, device, {}, true, this.parentModule)
      }
    }
  })
</script>